<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer6">
      <b-row>
        <b-col class="col-12">
          <b>
            <label>Attestation Of Eligibility For An Enrollment Period</label>
          </b>
          <p><b>Typically, you may enroll in a Medicare Advantage plan only during the annual enrollment
            period from October 15 through December 7 of each year.</b> There are exceptions that may
            allow you to enroll in a Medicare Advantage plan outside of this period.
          </p>
          <p>Please read the following statements carefully and check the box if the statement applies to you. By checking any of the following boxes you are certifying that, to the best of your knowledge, you are eligible for an Enrollment Period. If we later determine that this information is incorrect, you may be disenrolled.</p>
          <hr />
          <validation-provider
            rules="atleastone"
            :bails="false"
            v-slot="{ classes, errors }"
            class="col-3 p-0 mr-1"
            vid="atLeastOneAttestationSelected"
            name="selection"
            v-if="!isAEP"
          >
            <div class="control" :class="classes" v-if="!isAEP">
              <input
                type="text"
                v-show="false"
                v-model="atLeastOneAttestationSelected"
                ref="atLeastOneAttestationSelected"
              />
              <span>{{errors[0]}}</span>
            </div>
          </validation-provider>
          <b-form-checkbox
            id="checkbox-1"
            v-model="form.AttestationEligibility.newtomedicare"
            @change="setStatementSelected(form.AttestationEligibility.newtomedicare)"
            label-class="col-12"
            name="checkbox-1"
            value="Y"
            unchecked-value="N"
            ref="newtomedicare"
          >I am new to Medicare</b-form-checkbox>
          <b-form-checkbox
            id="checkbox-2"
            v-model="form.AttestationEligibility.maoep"
            @change="setStatementSelected(form.AttestationEligibility.maoep)"
            name="checkbox-2"
            value="Y"
            unchecked-value="N"
          >I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Open Enrollment Peroid (MA OEP)</b-form-checkbox>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.movedoutsideservicearea)"
            id="checkbox-3"
            v-model="form.AttestationEligibility.movedoutsideservicearea"
            name="checkbox-3"
            value="Y"
            unchecked-value="N"
            label-class="col-4"
          >I recently moved outside of the service area for my current plan or I recently moved and this plan is a new option for me. I moved on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.movedoutsideserviceareaDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2 customSmallInputGap d-inline-block"
            v-if="form.AttestationEligibility.movedoutsideservicearea=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.relfromincarceration)"
            id="checkbox-4"
            v-model="form.AttestationEligibility.relfromincarceration"
            name="checkbox-4"
            label-class="col-12"
            value="Y"
            unchecked-value="N"
          >I recently was released from incarceration. I was released on</b-form-checkbox>
          <div class="clearfix"></div>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.relfromincarcerationDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.relfromincarceration=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.returnedToUS)"
            id="checkbox-5"
            v-model="form.AttestationEligibility.returnedToUS"
            name="checkbox-5"
            value="Y"
            unchecked-value="N"
          >I recently returned to the United States after living permanently outside of the U.S. I returned to the U.S. on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.returnedToUSDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.returnedToUS=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.lawStatusUS)"
            id="checkbox-6"
            v-model="form.AttestationEligibility.lawStatusUS"
            name="checkbox-6"
            value="Y"
            unchecked-value="N"
          >I recently obtained lawful presence status in the United States. I got this status on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.lawStatusUSDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.lawStatusUS=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.medicaidChange)"
            id="checkbox-7"
            v-model="form.AttestationEligibility.medicaidChange"
            name="checkbox-7"
            value="Y"
            unchecked-value="N"
          >I recently had a change in my Medicaid (newly got Medicaid, had a change in level of Medicaid assistance, or lost Medicaid) on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.medicaidChangeDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.medicaidChange=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.extrahelppayingmedicare)"
            id="checkbox-8"
            v-model="form.AttestationEligibility.extrahelppayingmedicare"
            name="checkbox-8"
            value="Y"
            unchecked-value="N"
          >I recently had a change in my Extra Help paying for Medicare prescription drug coverage (newly got Extra Help, had a change in the level of Extra Help, or lost Extra Help) on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.extrahelppayingmedicareDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.extrahelppayingmedicare=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
                  @change="setStatementSelected(form.AttestationEligibility.bothMedicarenMedicaid)"
                  id="checkbox-20"
                  v-model="form.AttestationEligibility.bothMedicarenMedicaid"
                  name="checkbox-20"
                  value="Y"
                  unchecked-value="N"
          >I have both Medicare and Medicaid (or my state helps pay for my Medicare premiums) or I get Extra Help paying for my Medicare prescription drug coverage, but I haven’t had a change.</b-form-checkbox>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.moveinoutLTCareFacility)"
            id="checkbox-9"
            v-model="form.AttestationEligibility.moveinoutLTCareFacility"
            name="checkbox-9"
            value="Y"
            unchecked-value="N"
          >I am moving into, live in, or recently moved out of a Long-Term Care Facility (for example, a nursing home or long term care facility). I moved/will move into/out of the facility on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.moveinoutLTCareFacilityDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.moveinoutLTCareFacility=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>

          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.paceProgramLeft)"
            id="checkbox-10"
            v-model="form.AttestationEligibility.paceProgramLeft"
            name="checkbox-10"
            value="Y"
            unchecked-value="N"
          >I recently left a PACE program on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.paceProgramLeftDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.paceProgramLeft=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.lostDrugCoverage)"
            id="checkbox-11"
            v-model="form.AttestationEligibility.lostDrugCoverage"
            name="checkbox-11"
            value="Y"
            unchecked-value="N"
          >I recently involuntarily lost my creditable prescription drug coverage (coverage as good as Medicare's). I lost my drug coverage on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.lostDrugCoverageDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.lostDrugCoverage=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.leavingEmpUnionCoverage)"
            id="checkbox-12"
            v-model="form.AttestationEligibility.leavingEmpUnionCoverage"
            name="checkbox-12"
            value="Y"
            unchecked-value="N"
          >I am leaving employer or union coverage on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.leavingEmpUnionCOverageDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.leavingEmpUnionCoverage=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.pharmacyAssProg)"
            id="checkbox-13"
            v-model="form.AttestationEligibility.pharmacyAssProg"
            name="checkbox-13"
            value="Y"
            unchecked-value="N"
          >I belong to a pharmacy assistance program provided by my state.</b-form-checkbox>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.medicareContractEnding)"
            id="checkbox-14"
            v-model="form.AttestationEligibility.medicareContractEnding"
            name="checkbox-14"
            value="Y"
            unchecked-value="N"
          >My plan is ending its contract with Medicare, or Medicare is ending its contract with my plan.</b-form-checkbox>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.enrolledInMedicarePlan)"
            id="checkbox-15"
            v-model="form.AttestationEligibility.enrolledInMedicarePlan"
            name="checkbox-15"
            value="Y"
            unchecked-value="N"
          >I was enrolled in a plan by Medicare (or my state) and I want to choose a different plan. My enrollment in that plan started on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.enrolledInMedicarePlanDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.enrolledInMedicarePlan=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.disenrolledSNP)"
            id="checkbox-16"
            v-model="form.AttestationEligibility.disenrolledSNP"
            name="checkbox-16"
            value="Y"
            unchecked-value="N"
          >I was enrolled in a Special Needs Plan (SNP) but I have lost the special needs qualification to be in that plan. I was disenrolled from the SNP on</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.disenrolledSNPDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.disenrolledSNP=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <b-form-checkbox
            @change="setStatementSelected(form.AttestationEligibility.weatherEmergency)"
            id="checkbox-17"
            v-model="form.AttestationEligibility.weatherEmergency"
            name="checkbox-17"
            value="Y"
            unchecked-value="N"
          >I was affected by a weather-related emergency or major disaster (as declared by the Federal Emergency Management Agency -FEMA). One of the other states here applied to me, but I was unable to make my enrollment because of the natural disaster.</b-form-checkbox>
          <b-form-datepicker
            id="example-i18n-picker"
            v-model="form.AttestationEligibility.weatherEmergencyDate"
            :locale="'en-US'"
            :show-decade-nav="true"
            :date-format-options="{ year: 'numeric', month: 'short' }"
            class="mb-1 col-sm-6 col-md-5 col-lg-3 col-xl-2"
            v-if="form.AttestationEligibility.weatherEmergency=='Y'"
            placeholder="Select Date"
          ></b-form-datepicker>
          <br />
          <p>If none of these statements applies to you or you’re not sure, please contact {{form.AttestationEligibility.PayerPlan}} Plan. at {{form.AttestationEligibility.PayerPhoneNumber}} (TTY users should call 711) to see if you are eligible to enroll. We are open 8 a.m. to 8 p.m. Monday through Friday and daily during the enrollment period.</p>
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

export default {
  name: "AttestationEligibility",
  components: {},
  data() {
    return {
      atLeastOneAttestationSelected: 0,
      isAEP: false
    };
  },
  props: {
    form: Object
  },
  async created(){
    let octDate = new Date();
    octDate.setMonth(9);
    octDate.setDate(15);

    let todayDate = new Date();

    let decDate = new Date();
    decDate.setMonth(11);
    decDate.setDate(7);

    this.isAEP = todayDate >= octDate && todayDate <= decDate ;
  },
  methods: {

    setStatementSelected: function(val) {
      console.log("selection val ---- ",val);
      if (!val || val === "N") {
        if(this.atLeastOneAttestationSelected > 0) {
          this.atLeastOneAttestationSelected--;
        }
      } else {
        this.atLeastOneAttestationSelected++;
      }
      console.log(
        this.atLeastOneAttestationSelected
      );
    }
  }
};
</script>
